































import firebase, { firestore, functions } from "firebase";
import { Component, Prop, Vue, Watch } from 'vue-property-decorator';
import _ from 'lodash';
import { ItemDocument } from '../struct/psdocument';
import * as D from '../struct/personal';
import moment from "moment"


type RecordY<X, Y> = Required<{ [K in keyof X]: Y }>
/**
 * 編集用オブジェクト
 */
type EditTypeExCategory = Omit<ReturnType<typeof ItemDocument.skeltonTask>, "category">
type EditType = RecordY<EditTypeExCategory, string>
type EditableField = keyof EditType
/**
 * 生成されるオブジェクト
 */
type ValueType = Pick<D.TaskItem, EditableField>

/**
 * バリデータ
 */
type ValidatorType<Field extends EditableField> = D.Validator<EditType[Field], ValueType[Field]>;
type BackporterType<Field extends EditableField> = (value: any) => EditType[Field];
/**
 * 編集画面定義
 */
type EditControlType = "SinglelineText" | "MultilineText" | "DateText" | "YesNo"
const editDefinition: { 
  [K in EditableField]: {
    controlType: EditControlType
    validator: ValidatorType<K>
    backporter: BackporterType<K>
    placeholder?: string
  }
} = {
  title: {
    placeholder: "タイトル",
    controlType: "SinglelineText",
    validator: D.RequiredStringValidator,
    backporter: (value) => value,
  },
  deadlineTime: {
    placeholder: "期限",
    controlType: "DateText",
    validator: D.String2DateValidator,
    backporter: (value) => value ? moment(value).format("YYYY-MM-DD HH:mm") : "",
  },
  desc: {
    placeholder: "詳細",
    controlType: "MultilineText",
    validator: D.OptionalStringValidator,
    backporter: (value) => value || "",
  },
  wip: {
    placeholder: "仕掛中",
    controlType: "YesNo",
    validator: D.YesNoValidator,
    backporter: (value) => value ? "Yes" : "No",
  }
}

/**
 * バリデート後のオブジェクト
 */
type ValidatedType = { [K in EditableField]: ReturnType<ValidatorType<K>> }
const editableFieldKeys: EditableField[] = [
  "title",
  "deadlineTime",
  "desc",
  "wip",
]

@Component
export default class PersonalAdd extends Vue {
  @Prop() targetItem!: any

  @Watch("targetItem")
  targetGiven() { this.flush() }

  get editableFields() {
    return editableFieldKeys.map((field) => ({ field, ...editDefinition[field] }));
  }

  private editItem: EditType = {
    title: "",
    desc: "",
    deadlineTime: "",
    wip: "No",
  }

  flush() {
    if (!this.targetItem) { return }
    console.log(this.targetItem);
    _.each(editableFieldKeys, (k) => {
      const ed = editDefinition[k];
      this.$set(this.editItem, k, ed.backporter(this.targetItem[k]))
    })
  }

  get validatedValues(): ValidatedType {
    return _.mapValues(editDefinition, (def, key: EditableField) => def.validator(this.editItem[key])) as any
  }

  get validatedItem(): ValueType | undefined {
    if (_.some(this.validatedValues, (v) => v.isError)) { return undefined }
    return _.mapValues(this.validatedValues, (v) => v.value) as any
  }

  @Watch("validatedItem")
  itemChanged() {
    if (this.validatedItem) {
      this.$emit("itemChanged", this.validatedItem)
    }
  }

  mounted() {
    console.log("mtd")
  }

  created() {
    console.log("ctd")
    this.flush()
  }
}
